const focus = (state = false, action) => {
    switch(action.type) {
        case 'focus':
            return action.payload;
        default:
            return state;
    }
}

export default focus;